var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"cta",attrs:{"id":"cta"}},[_c('div',{staticClass:"container",attrs:{"data-aos":"zoom-in"}},[_c('div',{staticClass:"text-center"},[_c('h3',[_vm._v(_vm._s(_vm.$t("cta.title")))]),_c('p',[_vm._v(" "+_vm._s(_vm.$t("cta.descr"))+" ")]),_c('a',{staticClass:"cta-btn",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.$t("cta.but")))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }